import { useTranslation } from 'react-i18next';
import LZString from 'lz-string';
import "./toggle-switch.scss"

type ToggleProps = {
    isHorizontalView: boolean;
    setIsHorizontalView: (isHorizontalView: boolean) => void;

    updateUrl: (suffixUrl: string) => void;
    currentUrl: string;
    setIsAddToList: (isAddToList: boolean) => void;
    setAppliedFilters: (appliedFilters: any) => void;
}

const ToggleSwitch: React.FC<ToggleProps> = (props) => {
    const { isHorizontalView, currentUrl, setIsHorizontalView, updateUrl, setIsAddToList, setAppliedFilters } = props
    const { t } = useTranslation();

    const onToggle = (event: any) => {
        let urlParamsToggleSwitch =
            currentUrl === ''
                ? new URLSearchParams()
                : new URLSearchParams(new URL('', currentUrl).search);

        const decodedParams = new URLSearchParams(
            '?' +
            LZString.decompressFromEncodedURIComponent(urlParamsToggleSwitch.get('s')!)
        );

        setIsHorizontalView(event.target.checked)
        decodedParams.set('isHorizontalView', event.target.checked.toString());
        decodedParams.delete('selectedDataIds');

        setAppliedFilters([]);
        decodedParams.delete('filter');
        decodedParams.delete('filterOrder');
        updateUrl(
            LZString.compressToEncodedURIComponent(decodedParams.toString())
        );

        setIsAddToList(false);

    }


    return (
      <label className="switch">
        <input
          type="checkbox"
          checked={isHorizontalView}
          data-testid="switch-button"
          onChange={onToggle}
        />
        <span className="slider">
          <span
            className={`text-slider text-slider-stacked ${
              !isHorizontalView ? 'text-active' : 'text-not-active'
            }`}
          >
            {t('xref-part-columns')}
          </span>
          <span
            className={`text-slider text-slider-scrolling ${
              isHorizontalView ? 'text-active' : 'text-not-active'
            }`}
          >
            {t('xref-part-rows')}
          </span>
        </span>
      </label>
    );
}

export default ToggleSwitch